import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ShiftSummary } from 'src/app/core/interfaces/shift-summery';
import {
  getShiftSummaryRowNetValue,
  getShiftSummaryRowReturnValue,
  getShiftSummaryRowSaleValue,
  SHIFT_SUMMARY_ROWS,
  ShiftSummaryRowDef,
} from 'src/app/core/utils/shift-summary-row.util';

@Component({
    selector: 'app-shift-summary-display',
    templateUrl: './shift-summary-display.component.html',
    styleUrls: ['./shift-summary-display.component.scss']
})
export class ShiftSummaryDisplayComponent {
    @Input() shiftSummary: ShiftSummary | null = null;
    @Input() showPrintButton: boolean = true;
    @Input() showCloseButton: boolean = false;
    @Input() showClosingDetails: boolean = false;
    @Input() closingNotes: string = '';
    @Input() actualCashAmount: number = 0;
    @Input() actualCardAmount: number = 0;
    @ViewChild('printTemplate', { static: false }) printTemplate!: any;

    @Output() printSummary = new EventEmitter<void>();
    @Output() closeSummary = new EventEmitter<void>();

    rows: ShiftSummaryRowDef[] = SHIFT_SUMMARY_ROWS;

    getRowSaleValue(row: ShiftSummaryRowDef): number {
        return this.shiftSummary ? getShiftSummaryRowSaleValue(this.shiftSummary, row) : 0;
    }

    getRowReturnValue(row: ShiftSummaryRowDef): number | null {
        return this.shiftSummary ? getShiftSummaryRowReturnValue(this.shiftSummary, row) : null;
    }

    getRowNetValue(row: ShiftSummaryRowDef): number {
        return this.shiftSummary ? getShiftSummaryRowNetValue(this.shiftSummary, row) : 0;
    }

    get requiredDiff(): number {
        if (!this.shiftSummary) return 0;
        return this.actualCashAmount - this.shiftSummary.totalCash;
    }

    get budgetDiff(): number {
        if (!this.shiftSummary) return 0;
        return this.actualCardAmount - this.shiftSummary.totalCreditCard;
    }

    onPrint(): void {
        if (this.printTemplate) {
            this.printTemplate.print();
        } else {
            this.printSummary.emit();
        }
    }

    onClose(): void {
        this.closeSummary.emit();
    }

    /**
 * Get the translated status text for the shift
 */
    getTranslatedStatus(status: string): string {
        const statusMap: { [key: string]: string } = {
            'ShiftsOpen': 'SHIFT_SUMMARY.STATUS_OPEN',
            'ShiftsClosed': 'SHIFT_SUMMARY.STATUS_CLOSED',
            'ShiftsClose': 'SHIFT_SUMMARY.STATUS_CLOSE',
            'ShiftsStage': 'SHIFT_SUMMARY.STATUS_STAGE',
            'ShiftsPending': 'SHIFT_SUMMARY.STATUS_PENDING',
            'ShiftsCancelled': 'SHIFT_SUMMARY.STATUS_CANCELLED',
            'ShiftsSuspended': 'SHIFT_SUMMARY.STATUS_SUSPENDED'
        };

        return statusMap[status] || status;
    }

    /**
     * Get the appropriate CSS class for the status badge
     */
    getStatusBadgeClass(status: string): string {
        switch (status) {
            case 'ShiftsClosed':
            case 'ShiftsClose':
                return 'bg-success';
            case 'ShiftsOpen':
                return 'bg-warning';
            case 'ShiftsStage':
                return 'bg-info';
            case 'ShiftsPending':
                return 'bg-info';
            case 'ShiftsCancelled':
                return 'bg-danger';
            case 'ShiftsSuspended':
                return 'bg-secondary';
            default:
                return 'bg-secondary';
        }
    }
}
